import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query = '') {
    return ApiService.get(`reporting-analysis-manager/reports/payment-approvals?${query}`)
  },

  async post (payload) {
    return ApiService.post('reporting-analysis-manager/reports/payment-approvals', payload)
  },

  async put (payload) {
    return ApiService.put(`reporting-analysis-manager/reports/payment-approvals/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`reporting-analysis-manager/reports/payment-approvals/${payload.id}`)
  }
}

export default HistoryService
